/**
 * @module newsFeed
 */
(function () {
    "use strict";
    /**
     * Initialise the slick slider in the news feed
     * 
     * @memberof module:newsFeed
     * @instance
     * @private
     */
    function initNewsFeed() {

        //check if more than two items
        if($('.qld__news-feed__item').length > 2) {

            $('.qld__news-feed').slick({
                infinite: true,
                slidesToShow: 2.99,
                centerMode: false,
                slidesToScroll: 1,
                adaptiveHeight:true,
                dots: true,
                respondTo:'min',
                appendArrows:$('.qld__news-feed-controls--content'),
                appendDots:$('.qld__news-feed-controls--content'),
                prevArrow:'<button type="button" class="controls-prev"><i class="fa fa-chevron-left"></i></button>',
                nextArrow:'<button type="button" class="controls-next"><i class="fa fa-chevron-right"></i></button>',
                responsive: [
                    {
                        breakpoint:1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint:591,
                        settings: {
                            slidesToShow: 1

                        }
                    }
                ]
            });
            $(window).on("resize", function () {
                if ($(window).width() > breakpoint.Md) {
                    return;
                }

                $slick.each(function() {
                    var $this = $(this);

                    if (!$this.hasClass("slick-initialized") && $this.attr('data-type') == 'mobile-only' && $this.children('li').length > 1) {
                        $this.slick(slickSettingsMobileOnly);
                    }
                });
            });

        
        }

        // Change the text "Prev" to "Previous"
        var prevButton = document.querySelector('.qld__slick-prev');
        if (prevButton) {
            var srOnlyText = prevButton.querySelector('.sr-only');
            if (srOnlyText) {
                srOnlyText.textContent = "Previous";
            }
        }

        // Add event listeners for Next and Previous buttons to update the live region
        var prevButton = document.querySelector('.qld__slick-prev');
        var nextButton = document.querySelector('.qld__slick-next');
        var liveRegion = document.getElementById('aria-live-region');
        var newsItems = document.querySelectorAll('.qld__card__title');

        var currentIndex = 0;

        if (prevButton && nextButton && liveRegion) {
            prevButton.addEventListener('click', function() {
                if (currentIndex > 0) {
                    currentIndex--;
                }
                updateLiveRegion(liveRegion, currentIndex, newsItems[currentIndex]);
            });

            nextButton.addEventListener('click', function() {
                if (currentIndex < newsItems.length - 1) {
                    currentIndex++;
                }
                updateLiveRegion(liveRegion, currentIndex, newsItems[currentIndex]);
            });
        }
    }

        /**
         * Update the ARIA live region with a message
         *
         * @param {HTMLElement} liveRegion - The live region element
         * @param {number} index - The current index of the news item
         * @param {HTMLElement} titleElement - The <a> element containing the title
         */
        function updateLiveRegion(liveRegion, index, titleElement) {
            setTimeout(function() {
                // Update live region with the count and news title
                liveRegion.textContent = `Showing News item ${index + 1}: ${titleElement.querySelector('a').textContent}`;
            }, 200);
        }

    
    
    document.addEventListener('DOMContentLoaded', initNewsFeed);
})();
